import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "agencySelect", "programSection", "programSelect", "callSection", "callSelect",
    "newCallName", "newCallCode", "newCallUrl", "newCallOpenDate", "newCallCloseDate",
    "programName", "container"
  ]
  static values = {
    selectProgram: String,
    selectCall: String
  }

  connect() {
    this.selectedAgencyId = null
    this.selectedProgramId = null
    this.selectedProgramName = ""
    this.selectedAgencyName = ""
  }

  agencyChanged(event) {
    const agencyId = event.target.value
    this.selectedAgencyId = agencyId
    this.selectedAgencyName = event.target.options[event.target.selectedIndex]?.text || ""
    if (!agencyId) {
      this.programSectionTarget.classList.add("d-none")
      this.callSectionTarget.classList.add("d-none")
      this.programSelectTarget.innerHTML = `<option value="">${this.selectProgramValue || "Select program"}</option>`
      return
    }
    fetch(`/funding_agencies/${agencyId}/funding_programs.json`)
      .then(r => r.json())
      .then(programs => {
        let options = `<option value="">${this.selectProgramValue || "Select program"}</option>`
        programs.forEach(p => {
          options += `<option value="${p.id}">${p.name}</option>`
        })
        this.programSelectTarget.innerHTML = options
        this.programSectionTarget.classList.remove("d-none")
        this.callSectionTarget.classList.add("d-none")
      })
  }

  programChanged(event) {
    const programId = event.target.value
    this.selectedProgramId = programId
    this.selectedProgramName = event.target.options[event.target.selectedIndex]?.text || ""
    if (this.hasProgramNameTarget) this.programNameTarget.innerText = this.selectedProgramName
    if (!programId) {
      this.callSectionTarget.classList.add("d-none")
      this.callSelectTarget.innerHTML = `<option value="">${this.selectCallValue || "Select call"}</option>`
      return
    }
    fetch(`/funding_agencies/${this.selectedAgencyId}/funding_programs/${programId}/funding_calls.json`)
      .then(r => r.json())
      .then(calls => {
        let options = `<option value="">${this.selectCallValue || "Select call"}</option>`
        calls.forEach(c => {
          options += `<option value="${c.id}">${c.name}</option>`
        })
        this.callSelectTarget.innerHTML = options
        this.callSectionTarget.classList.remove("d-none")
      })
  }

  addExisting() {
    const callId = this.callSelectTarget.value
    if (!callId) return
    fetch(`/funding_calls/${callId}.json`)
      .then(r => r.json())
      .then(call => {
        this._addFundingCard({
          call_id: call.id,
          call_name: call.name,
          call_code: call.code,
          agency: this.selectedAgencyName,
          program: this.selectedProgramName,
          details_url: call.details_url || "",
          open_date: call.open_date || "",
          close_date: call.close_date || ""
        })
      })
  }

  addNew() {
    const name = this.newCallNameTarget.value.trim()
    const code = this.newCallCodeTarget.value.trim()
    if (!name || !code) return
    const url = this.newCallUrlTarget.value
    const open_date = this.newCallOpenDateTarget.value
    const close_date = this.newCallCloseDateTarget.value
    fetch(`/funding_agencies/${this.selectedAgencyId}/funding_programs/${this.selectedProgramId}/funding_calls.json`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": this._csrf() },
      body: JSON.stringify({ funding_call: { name, code, details_url: url, open_date, close_date } })
    })
      .then(r => r.json())
      .then(call => {
        this._addFundingCard({
          call_id: call.id,
          call_name: call.name,
          call_code: call.code,
          agency: this.selectedAgencyName,
          program: this.selectedProgramName,
          details_url: url,
          open_date: open_date,
          close_date: close_date
        })
        this.newCallNameTarget.value = ""
        this.newCallCodeTarget.value = ""
        this.newCallUrlTarget.value = ""
        this.newCallOpenDateTarget.value = ""
        this.newCallCloseDateTarget.value = ""
      })
  }

  remove(event) {
    const card = event.target.closest(".project-funding-item")
    if (!card) return

    // Marca o hidden _destroy como "1" se existir (Rails nested attributes)
    const destroyInput = card.querySelector('input[type="hidden"][name*="[_destroy]"]')
    if (destroyInput) {
      destroyInput.value = "1"
      card.style.display = "none"
    } else {
      // Se não existir (novo não salvo), remove do DOM
      card.remove()
    }
  }

  _addFundingCard({ call_id, call_name, call_code, agency, program, details_url, open_date, close_date, total_amount, local_amount }) {
    const idx = Date.now() + Math.floor(Math.random() * 10000)
    const wrapper = this.element.querySelector('.nested-form-wrapper')
    const templateDiv = document.getElementById("funding-card-template")
    if (!wrapper || !templateDiv) return

    let html = templateDiv.innerHTML.replace(/NEW_RECORD/g, idx)
    const tempDiv = document.createElement("div")
    tempDiv.innerHTML = html

    const fundingCallIdInput = tempDiv.querySelector(`[name="project[project_fundings_attributes][${idx}][funding_call_id]"]`)
    if (fundingCallIdInput) fundingCallIdInput.value = call_id

    const callTitle = tempDiv.querySelector(".funding-call-title")
    if (callTitle) callTitle.textContent = call_name

    // Preencher código
    const codeSpan = tempDiv.querySelector('[data-field="code"]')
    if (codeSpan) codeSpan.textContent = call_code || ""

    // Preencher campos usando data-field
    const agencyDiv = tempDiv.querySelector('[data-field="agency"]')
    if (agencyDiv) agencyDiv.textContent = agency || "-"

    const programDiv = tempDiv.querySelector('[data-field="program"]')
    if (programDiv) programDiv.textContent = program || "-"

    const detailsDiv = tempDiv.querySelector('[data-field="details_url"]')
    if (detailsDiv) {
      if (details_url) {
        detailsDiv.innerHTML = `<a href="${details_url}" target="_blank">${details_url}</a>`
      } else {
        detailsDiv.textContent = "-"
      }
    }

    const openDateDiv = tempDiv.querySelector('[data-field="open_date"]')
    if (openDateDiv) openDateDiv.textContent = open_date || "-"

    const closeDateDiv = tempDiv.querySelector('[data-field="close_date"]')
    if (closeDateDiv) closeDateDiv.textContent = close_date || "-"

    const totalAmountInput = tempDiv.querySelector(`[name="project[project_fundings_attributes][${idx}][total_amount]"]`)
    if (totalAmountInput) totalAmountInput.value = total_amount || ""

    const localAmountInput = tempDiv.querySelector(`[name="project[project_fundings_attributes][${idx}][local_amount]"]`)
    if (localAmountInput) localAmountInput.value = local_amount || ""
    
    // Add funded_amount input if it exists in the template
    const fundedAmountInput = tempDiv.querySelector(`[name="project[project_fundings_attributes][${idx}][funded_amount]"]`)
    if (fundedAmountInput) fundedAmountInput.value = ""

    wrapper.insertBefore(tempDiv.firstElementChild, wrapper.firstChild)
  }

  _csrf() {
    return document.querySelector("meta[name=csrf-token]")?.content
  }
}
